export class Constants {
    public static ROLES = {
        COLLABORATOR: {
            CODE: 1,
            NAME: "COLLABORATOR"
        },
        LEADER: {
            CODE: 2,
            NAME: "LEADER"
        },
        ADMIN: {
            CODE: 3,
            NAME: "ADMIN"
        },
        SUPERADMIN: {
            CODE: 4,
            NAME: "SUPERADMIN"
        }
    }

    public static STATUS_POLL = {
        NEW: {
            CODE: 1,
            DESCRIPTION: "ENUMS.POLL.NEW"
        },
        IN_PROGRESS:{
            CODE: 2,
            DESCRIPTION: "ENUMS.POLL.IN_PROGRESS"
        },
        PAUSE: {
            CODE: 3,
            DESCRIPTION: "ENUMS.POLL.PAUSE"
        },
        FINISH: {
            CODE: 4,
            DESCRIPTION: "ENUMS.POLL.FINISH"
        }
    }

    public static RESOURCE_TYPE = {
        VIDEO: 1,
        IMAGE: 2,
        PDF: 3,
        LINK: 4
    }

    public static RESOURCE_LEVEL = {
        INICIAL: 1,
        INTERMEDIO: 2,
        AVANZADO: 3
    }

    public static DELIVERY_SURVEY_ITEM_STATUS = {
        ON_HOLD: 0,
        ALREADY_RESPONDED: 1
    }

}